module.exports = __webpack_public_path__ + "img/kuaidiwang.41286dd3.png";